import { render, staticRenderFns } from "./index.vue?vue&type=template&id=637b9f80&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=637b9f80&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637b9f80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('637b9f80')) {
      api.createRecord('637b9f80', component.options)
    } else {
      api.reload('637b9f80', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=637b9f80&scoped=true", function () {
      api.rerender('637b9f80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/divide-class/index.vue"
export default component.exports